module.exports = __webpack_public_path__ + "img/yingixao.c3b38c06.png";